import { types as t, onSnapshot } from 'mobx-state-tree';

import { SmsResultsModel } from './models/sms/smsResults';
import { SmsDataModel } from './models/sms/smsData';
import { HlrDataModel } from './models/hlr/hlrData';
import { HlrResultsModel } from './models/hlr/hlrResults';
import { TimezonesDataModel } from './models/timezones/timezonesData';
import { initialHlrStore } from './models/hlr/initialHlrStore';
import { initialSmsStore } from './models/sms/initialSmsStore';
import { initialTimezonesStore } from './models/timezones/initialTimezonesStore';
import { SupplierPrefixesDataModel } from './models/supplierPrefixes/supplierPrefixesData';
import { initialSupplierPrefixesStore } from './models/supplierPrefixes/initialSupplierPrefixesStore';
import { CountryCodesDataModel } from './models/countryCodes/countryCodesData';
import { initialCountryCodesStore } from './models/countryCodes/initialCountryCodesStore';

const initialState = {
  sms: initialSmsStore,
  hlr: initialHlrStore,
  timezones: initialTimezonesStore,
  supplierPrefixes: initialSupplierPrefixesStore,
  countryCodes: initialCountryCodesStore,
};

const RootModel = t.model('RootModel', {
  sms: t.model({
    data: SmsDataModel,
    results: SmsResultsModel,
  }),
  hlr: t.model({
    data: HlrDataModel,
    results: HlrResultsModel,
  }),
  timezones: t.model({
    data: TimezonesDataModel,
  }),
  supplierPrefixes: t.model({
    data: SupplierPrefixesDataModel,
  }),
  countryCodes: t.model({
    data: CountryCodesDataModel,
  }),
});

export const rootStore = RootModel.create(initialState);

onSnapshot(rootStore, snapshot => {
  localStorage.setItem('tests-store', JSON.stringify(snapshot));
});
